<template>
  <div class="adult-password-wrap">
    <div class="adult-password-pin">
      <h1 class="logo a11y-hidden">
        <img :src="require('@/assets/images/common/ci-wavve.svg')" alt="Wavve" />
      </h1>

      <img :src="require('@/assets/images/common/ico-common-19.png')" alt="19" class="adult-icon"/>

      <div class="adult-explain-box" tabindex="0">
        <h2 class="adult-title">
          <span>{{titleObj.title}}</span>
        </h2>
        <p class="adult-explain">
          <span>{{titleObj.subTitle}}</span>
          <span v-if="adultCheckForDownload" class="adult-date">확인 버튼 클릭 후 다시 다운로드 진행해주시길 바랍니다.</span>
        </p>
      </div>

      <form action="#" @click.prevent="formClick()">
        <fieldset>
          <legend class="a11y-hidden">비밀번호 입력 폼</legend>
          <div class="password">
            <div
              v-for="(digit, index) in ['1', '2', '3', '4']"
              :key="index"
              :class="getPinCodeClass(pinCode[index])"
            >
              <label :for="`password${index}`" class="a11y-hidden">{{ digit }} 번째 자리</label>
              <input
                type="text"
                :id="`password${index}`"
                class="pw-inputs"
                name="password"
                v-model.number="pinCode[index]"
                @keyup="changePinCode(index)"
                @keydown.delete="deletePinCode(index)"
                maxlength="1"
                placeholder="0부터 9사이의 번호를 입력해주세요."
                autocomplete="off"
                required
              >
              <span class="pw-img" />
            </div>
          </div>
        </fieldset>
      </form>
      <div class="button-box">
        <div class="password-reset">
          <button @click.prevent="pinCodeReset()">성인 비밀번호 초기화</button>
        </div>
        <div class="button-item">
          <button type="button" @click.prevent="cancel()" class="button-cancel">취소</button>
          <button type="button" @click.prevent="check()" id="button-confirm" class="button-confirm">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { postAdultOtt, postAdultConfirm } from '@/common/utils/request'
  import { setCookieAdultSetting, setCookieVerifiedAdult } from '@/common/utils/adult'
  import cookie from '@/common/utils/cookie'
  import _ from 'lodash'
  import constant from '@/common/resources/constant'
  import { ADULT_CHECK_TYPE_DOWNLOAD } from '@/common/resources/const'
  import { PATH_NAME_PINCODE_COMPLETE } from '@/common/resources/router.const'

  export default {
    name: 'PinCodeCheck',
    data () {
      return {
        pinCode: ['', '', '', ''],
        type: _.get(this.$route, 'query.type', ''),
        isOtt: 'n',
        settings: _.get(this.$route, 'query.settings', 'N'),
        enterUrl: _.get(this.$route, 'query.enter', '/index.html'),
        refererUrl: _.get(this.$route, 'query.referer', '/index.html'),
        orgSettings: _.get(this.$route, 'query.orgSettings', 'N'),
        pinCodeLength: 1
      }
    },
    computed: {
      titleObj () {
        switch (this.type) {
          case 'child' : // child: 자녀 보호 설정 - 성인 콘텐츠 설정 - 성인 콘텐츠 장금
            return { title: '자녀보호 설정', subTitle: '자녀보호를 위한 설정으로 성인만 설정 가능합니다.' }

          case 'ott' : // ott: 스마트 tv 에서 성인 인증 설정을 하다가 웹에서 처음으로 성인인증 설정을 했을 경우
            return { title: '성인 비밀번호 설정', subTitle: 'Wavve TV 앱에서 사용중인 성인 비밀번호 4자리를 입력해주세요.' }

          case 'adult' : // adult: 성인 콘텐츠 - 성인 제한 콘텐츠
            return { title: '연령 제한 콘텐츠', subTitle: '시청하시려면 성인 비밀번호 4자리를 입력해주세요.' }

          default :
            return { title: '연령 제한 콘텐츠', subTitle: '시청하시려면 성인 비밀번호 4자리를 입력해주세요.' }
        }
      },
      adultCheckForDownload () {
        return this.$route.meta.type === ADULT_CHECK_TYPE_DOWNLOAD
      }
    },
    methods: {
      getPinCodeClass (target) {
        return String(target) ? 'pw-each on' : 'pw-each'
      },
      changePinCode (id) {
        let element = document.getElementById('password' + id)
        let nextElement = document.getElementById('password' + (id + 1))
        if (element && nextElement && '' + this.pinCode[id]) {
          this.focusOn(nextElement)
        }
      },
      deletePinCode (id) {
        let element = document.getElementById('password' + id)
        let prevElement = document.getElementById('password' + (id - 1))
        if (element && prevElement && !('' + this.pinCode[id])) {
          this.focusOn(prevElement)
        }
      },
      resetInputPinCode () {
        this.pinCode = ['', '', '', '']
        this.focusOn(document.getElementById('password0'))
      },
      check () {
        const pinCode = this.pinCode.join('')
        if (pinCode.length < 4) {
          alert(constant.MSG_ONLY_INPUT_FOUR_DIGITS)
          this.resetInputPinCode()
          return
        }
        let ApiResponse
        if (this.isOtt === 'y') {
          ApiResponse = postAdultOtt({ pinCode: pinCode, settings: this.settings })
        } else {
          if (this.type === 'adult') {
            ApiResponse = postAdultConfirm({ pinCode: pinCode })
          } else {
            ApiResponse = postAdultConfirm({ pinCode: pinCode, settings: this.settings })
          }
        }
        ApiResponse.then(({ data }) => {
          if (_.get(data, 'resultcode', '') === '200') {
            if (this.type === 'adult') {
              setCookieVerifiedAdult()
              this.$router.replace(decodeURIComponent(this.enterUrl))
            } else {
              setCookieAdultSetting('adult-settings', this.settings)
              cookie.removeItems({ keyList: ['targetage', 'verifiedAdult'] })
              if (this.type === 'ott') {
                this.$router.push({ name: PATH_NAME_PINCODE_COMPLETE })
              } else {
                this.$router.back()
              }
            }
          }
        }).catch((err) => {
          alert(_.get(err, 'response.data.resultmessage', ''))
          this.resetInputPinCode()
        })
      },
      cancel () {
        if (this.type === 'adult') {
          this.$router.push(this.refererUrl)
        } else {
          this.$router.back()
        }
      },
      pinCodeReset () {
        if (confirm(constant.MSG_ADULT_PASSWORD_RESET)) {
          const callback = encodeURIComponent(`${window.location.origin}/callback.html?action=updateVerifiedInfo&result=`)
          const url = `https://member.wavve.com/auth/verifyage?type=pin&callback=${callback}`
          window.open(url, '', 'width=1440, height=800, scrollbars=yes')
        }
      },
      formClick () {
        const pinCode = this.pinCode.join('')
        this.focusOn(document.getElementById('password' + (pinCode.length)))
      },
      focusOn (el) {
        if (el) {
          el.focus()
        }
      },
      postMessage (e) {
        if (e.origin === location.origin && e.data === 'updateVerifiedInfo') {
          this.$router.back()
        }
      }
    },
    mounted () {
      this.focusOn(document.getElementById('password0'))
      window.addEventListener('keyup', event => {
        let agent = navigator.userAgent.toLowerCase()
        if (event.keyCode === 8) {
          if (agent.indexOf('msie') !== -1 || agent.indexOf('trident') !== -1) {
            const pinCodeLength = this.pinCode.join('').length
            this.deletePinCode(pinCodeLength)
          }
        }
      })
      window.addEventListener('message', this.postMessage)
    },
    watch: {
      pinCode () {
        let pinCode = this.pinCode.join('')
        if (isNaN(Number(pinCode))) {
          pinCode = pinCode.replace(/[^0-9]/g, '')
          this.pinCode[pinCode.length] = ''
          this.focusOn(document.getElementById('password' + pinCode.length))
        }
        if (pinCode.length > 4) {
          alert(constant.MSG_ONLY_INPUT_FOUR_DIGITS)
          this.resetInputPinCode()
        }
      }
    },
    created () {
      this.isOtt = this.type === 'ott' ? 'y' : 'n'
    },
    beforeDestroy () {
      window.removeEventListener('message', this.postMessage)
    }
  }
</script>
<style lang="scss" src="@/assets/scss/category/adult.scss"></style>
